module.exports = "http://cdn.realive.com.ua/src/views/player/jobselector/assets/images/lock.svg";